import React from 'react';
import { connect } from 'react-redux';
import NbCommentairesIndicateur from './NbCommentairesIndicateur';
import { fetchReclamationsCommentairesIfNeeded } from 'store/reclamation/indicateursActions';
import { updateRechercheCriteres } from 'store/reclamation/reclamationsActions';
import { ReclamationFiltre } from '../../../../../constants';

class NbCommentairesIndicateurContainer extends React.Component {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.props.fetchReclamationsCommentairesIfNeeded();
    }


    componentDidUpdate(prevProps) {
        if (this.props.didInvalidate && !prevProps.didInvalidate) {
            this.props.fetchReclamationsCommentairesIfNeeded();
        }
    }

    handleClick() {
        this.props.updateRechercheCriteres({
            filtre: ReclamationFiltre.Commentaires,
        });
    }

    render() {
        return <NbCommentairesIndicateur isLoading={this.props.isLoading} count={this.props.valeur} onClick={this.handleClick} />;
    }
}

const mapStateToProps = state => ({
    valeur: state.reclamation.indicateurs.commentaires.valeur,
    isLoading: state.reclamation.indicateurs.commentaires.isLoading,
    didInvalidate: state.reclamation.indicateurs.creees.didInvalidate
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationsCommentairesIfNeeded: () => dispatch(fetchReclamationsCommentairesIfNeeded()),
    updateRechercheCriteres: criteres => dispatch(updateRechercheCriteres(criteres))
});

export default connect(mapStateToProps, mapDispatchToProps)(NbCommentairesIndicateurContainer);